import React, { ChangeEvent, useRef } from 'react';
import { Col, Row } from 'react-bootstrap';
import { InputSelect, InputText } from '~/components/NovosInputs';
import { useAjusteDePara } from '../../hooks/useAjusteDePara';
import { CanceladoContainer } from '../../styles';

export const FormProdDerivado: React.FC = () => {
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);
  const {
    formTela: {
      register,
      control,
      formState: { errors },
      setValue,
      clearErrors,
    },
    isUpdate,
    prodTable,
    tipoAjusteEntrada,
    prodDerivado,
    flgCancelado,
    handleFocusInput,
  } = useAjusteDePara();

  const recalcularQtdDerivado = (qtd_ajuste: number) => {
    // timeOut para chamar as funções de calculo apenas 1 vez, após o tempo estipulado
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    timeoutRef.current = setTimeout(() => {
      const resCalc = prodTable.val_peso_emb * qtd_ajuste;
      setValue('qtd_derivado', resCalc);
      clearErrors('qtd_derivado');
    }, 500);
  };

  return (
    <>
      <Row className="mt-3">
        <Col sm={12} md={2}>
          <InputText
            label="Quantidade de Ajuste *"
            name="qtd_ajuste"
            alignRight
            placeholder="0"
            maxLength={10}
            max={9999999999}
            min={1}
            register={register}
            control={control}
            disabled={isUpdate}
            isError={!!errors.qtd_ajuste}
            onInput={(e: ChangeEvent<HTMLInputElement>) => {
              const numbersOnly = e.target.value.replace(/\D/g, '');
              setValue('qtd_ajuste', numbersOnly);
              recalcularQtdDerivado(Number(numbersOnly));
            }}
          />
        </Col>
        <Col sm={12} md={2}>
          <InputText
            label="Derivado Receberá *"
            name="qtd_derivado"
            alignRight
            placeholder="0"
            maxLength={20}
            disabled
            register={register}
            control={control}
            isError={!!errors.qtd_derivado}
          />
        </Col>
        {flgCancelado && (
          <CanceladoContainer>
            <h3 className="cancel">CANCELADO</h3>
          </CanceladoContainer>
        )}
      </Row>
      <Row className="mt-3">
        <Col sm={12} md={6}>
          <InputSelect
            label="Produto Derivado *"
            name="cod_produto_derivado"
            placeholder="Selecione..."
            register={register}
            disabled={isUpdate}
            control={control}
            isError={!!errors.cod_produto_derivado}
            options={prodDerivado}
            changeSelected={(selected) => {
              setValue('cod_produto_derivado', selected);
              clearErrors('cod_produto_derivado');
              handleFocusInput('cod_tipo_ajuste_derivado');
            }}
          />
        </Col>
        <Col sm={12} md={6}>
          <InputSelect
            label="Tipo de Ajuste *"
            name="cod_tipo_ajuste_derivado"
            placeholder="Selecione..."
            register={register}
            control={control}
            disabled={isUpdate}
            isError={!!errors.cod_tipo_ajuste_derivado}
            options={tipoAjusteEntrada}
            changeSelected={(selected) => {
              setValue('cod_tipo_ajuste_derivado', selected);
              clearErrors('cod_tipo_ajuste_derivado');
            }}
          />
        </Col>
      </Row>
    </>
  );
};
